import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon70: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 13.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 13" width={width} height={height} {...props}>
      <Path
        d="M16.5 12C15.121 12 14 10.879 14 9.5C14 8.665 14.415 7.93001 15.045 7.47601L16.044 9.70398C16.127 9.88998 16.31 10 16.5 10C16.568 10 16.638 9.98599 16.704 9.95599C16.956 9.84399 17.069 9.54802 16.956 9.29602L15.955 7.06299C16.131 7.02399 16.313 7 16.5 7C17.879 7 19 8.121 19 9.5C19 10.879 17.879 12 16.5 12ZM11.022 9H8.97501C8.82501 7.348 7.94001 5.905 6.65201 5H8.5C8.776 5 9 4.776 9 4.5C9 3.673 9.673 3 10.5 3H14.5C15.163 3 15.727 3.433 15.925 4.03C15.366 4.089 14.84 4.24501 14.344 4.45901C14.312 4.46601 14.28 4.46701 14.25 4.48001C14.232 4.48801 14.222 4.50299 14.206 4.51199C12.462 5.31699 11.203 7.002 11.022 9ZM3.5 12C2.121 12 1 10.879 1 9.5C1 8.121 2.121 7 3.5 7C4.708 7 5.71701 7.86 5.94901 9H3.5C3.224 9 3 9.224 3 9.5C3 9.776 3.224 10 3.5 10H5.94901C5.71701 11.14 4.708 12 3.5 12ZM16.5 6C16.167 6 15.851 6.06199 15.545 6.14899L15.135 5.23401C15.568 5.09601 16.021 5 16.5 5C16.776 5 17 4.776 17 4.5C17 3.121 15.879 2 14.5 2H13.685L13.355 1.26599C13.039 0.496991 12.297 0 11.466 0H10.5C10.224 0 10 0.224 10 0.5C10 0.776 10.224 1 10.5 1H11.466C11.891 1 12.27 1.254 12.438 1.66L12.59 2H10.5C9.293 2 8.28199 2.86 8.04999 4H1.5C1.224 4 1 4.224 1 4.5C1 4.776 1.224 5 1.5 5H3.5C5.811 5 7.69701 6.756 7.94901 9H6.94901C6.70401 7.309 5.259 6 3.5 6C1.57 6 0 7.57 0 9.5C0 11.43 1.57 13 3.5 13C5.259 13 6.70401 11.691 6.94901 10H11.5C11.776 10 12 9.776 12 9.5C12 7.854 12.898 6.42599 14.223 5.64099L14.631 6.552C13.654 7.174 13 8.259 13 9.5C13 11.43 14.57 13 16.5 13C18.43 13 20 11.43 20 9.5C20 7.57 18.43 6 16.5 6Z"
        fill="#404040"
      />
    </Icon>
  )
}
